export default __webpack_public_path__ + "static/media/gad_2.bee25e40.jpg";